import { Modal, Button, Typography, Space } from 'antd';
import { translate } from 'libs';
import { IDeactiveCodeProps } from 'pages/setting/interfaces';
import React, { memo } from 'react';

const DeactiveCode = ({
  isVisible,
  onCancel,
  code,
  handleDeactive,
  selectedItem,
  isLoading,
}: IDeactiveCodeProps) => {
  return (
    <Modal
      maskClosable={false}
      title={translate('settingPage.ogSetup.deactiveAccessCode')}
      centered
      visible={isVisible}
      onCancel={onCancel}
      footer={[
        <Button
          key="large"
          type="primary"
          className="btn-download"
          size="large"
          onClick={() => handleDeactive(code)}
          loading={isLoading}
        >
          {translate('settingPage.ogSetup.deactiveThisCode')}
        </Button>,
        <Button key="cancel" className="btn-close" size="large" onClick={onCancel}>
          {translate('common.cancelBtn')}
        </Button>,
      ]}
      className="md-deactive-code"
    >
      <Space size={20} direction="vertical" className="space-des">
        <Typography.Text className="txt-deactive  break-line-localize">
          {translate('settingPage.ogSetup.deactiveSure1', { code })}
        </Typography.Text>
      </Space>
    </Modal>
  );
};

export default memo(DeactiveCode);
